import { FormLabel, Grid, TextField } from "@mui/material";


export const ViewAndEditEntity = ({
  
    handleInputChange,
    index,
    row,
    viewMode,
    validationStatus,
}) => {
    //inline style
    const InlineStyle = {
        EntityDivison: {
            width: "230px", height: "32", padding: "0px"
        },
    }
    return (
      <form>
        <Grid container justifyContent={"space-between"} sx={{width:"80%"}}>
          <Grid
            item
            xs={3}
            display={"flex"}
            flexDirection={"column"}
            gap={"5px"}
            mt={"20px"}
          >
            <FormLabel>Allocation Status</FormLabel>
            <TextField
              value={row.allocation_status}
              onChange={(e) =>
                handleInputChange(index, "allocation_status", e.target.value)
              }
              sx={InlineStyle.EntityDivison}
              size="small"
              placeholder="Enter Details Here"
              disabled={viewMode}
            />
            <br />
            {validationStatus[index]?.allocation_status && (
              <span style={{ color: "red" }}>
                {validationStatus[index]?.allocation_status}
              </span>
            )}
          </Grid>
        
      
        </Grid>
      </form>
    );
}